import * as Immutable from "immutable";
import Parameter from "views/logic/parameters/Parameter";
const _WatchlistParameter = class _WatchlistParameter extends Parameter {
  constructor(name, title, description, dataType, defaultValue, optional, watchlistId) {
    super(_WatchlistParameter.type, name, title, description, dataType, defaultValue, optional);
    this._value2 = { watchlistId };
  }
  static create(_type, name, title, description, dataType, defaultValue, optional, watchlistId) {
    return new _WatchlistParameter(name, title, description, dataType, defaultValue, optional, watchlistId);
  }
  toBuilder() {
    const { type, name, title, description, dataType, defaultValue, optional } = this._value;
    const { watchlistId } = this._value2;
    return new Builder(
      Immutable.Map({
        type,
        name,
        title,
        description,
        dataType,
        defaultValue,
        optional,
        watchlistId
      })
    );
  }
  // eslint-disable-next-line class-methods-use-this
  get needsBinding() {
    return false;
  }
  get watchlistId() {
    return this._value2.watchlistId;
  }
  toJSON() {
    const { type, name, title, description, dataType, defaultValue, optional } = this._value;
    const { watchlistId } = this._value2;
    return {
      type,
      name,
      title,
      description,
      data_type: dataType,
      default_value: defaultValue,
      optional,
      binding: void 0,
      watchlist_id: watchlistId
    };
  }
  static fromJSON(json) {
    const { name, title, description, data_type, default_value, optional, watchlist_id } = json;
    return new _WatchlistParameter(name, title, description, data_type, default_value, optional, watchlist_id);
  }
  static builder() {
    return new Builder().type(_WatchlistParameter.type).optional(false).dataType("any");
  }
};
_WatchlistParameter.type = "watchlist-parameter-v1";
let WatchlistParameter = _WatchlistParameter;
export {
  WatchlistParameter as default
};
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  type(value) {
    return new Builder(this.value.set("type", value));
  }
  name(value) {
    return new Builder(this.value.set("name", value));
  }
  title(value) {
    return new Builder(this.value.set("title", value));
  }
  description(value) {
    return new Builder(this.value.set("description", value));
  }
  dataType(value) {
    return new Builder(this.value.set("dataType", value));
  }
  defaultValue(value) {
    return new Builder(this.value.set("defaultValue", value));
  }
  optional(value) {
    return new Builder(this.value.set("optional", value));
  }
  watchlistId(value) {
    return new Builder(this.value.set("watchlistId", value));
  }
  build() {
    const { name, title, description, dataType, defaultValue, optional, watchlistId } = this.value.toObject();
    return new WatchlistParameter(name, title, description, dataType, defaultValue, optional, watchlistId);
  }
}
WatchlistParameter.Builder = Builder;
